import AutoMatch from './autoMatch';

export default AutoMatch;
